
(function() {
  var result = { translations: { "ko": { "i18n": { "duration": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84", "days": "{{ days }}\uC77C", "shortForm": { "seconds": "{{ seconds }}\uCD08", "minutes": "{{ minutes }}\uBD84", "hours": "{{ hours }}\uC2DC\uAC04", "days": "{{ days }}\uC77C", "hoursAndMinutes": "{{ hours }}\uC2DC\uAC04 {{ minutes }}\uBD84" } }, "dateTime": { "quarterAndYear": "{{yearNumber}} {{quarterNumber}}\uBD84\uAE30" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}}{{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, \uB0B4\uC120\uBC88\uD638: {{extension}}" } } } } };
  result.translationsLoaded = {
  "I18n": {
    "ko": "static-7.1104"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "af": "static-7.1104",
    "ar-eg": "static-7.1104",
    "bg": "static-7.1104",
    "bn": "static-7.1104",
    "ca-es": "static-7.1104",
    "cs": "static-7.1104",
    "da": "static-7.1104",
    "de": "static-7.1104",
    "el": "static-7.1104",
    "en-gb": "static-7.1104",
    "en": "static-7.1104",
    "es-mx": "static-7.1104",
    "es": "static-7.1104",
    "et": "static-7.1104",
    "fi": "static-7.1104",
    "fr-ca": "static-7.1104",
    "fr": "static-7.1104",
    "he-il": "static-7.1104",
    "hi": "static-7.1104",
    "hr": "static-7.1104",
    "hu": "static-7.1104",
    "id": "static-7.1104",
    "it": "static-7.1104",
    "ja": "static-7.1104",
    "ko": "static-7.1104",
    "lt": "static-7.1104",
    "ms": "static-7.1104",
    "nl": "static-7.1104",
    "no": "static-7.1104",
    "pl": "static-7.1104",
    "pt-br": "static-7.1104",
    "pt-pt": "static-7.1104",
    "ro": "static-7.1104",
    "ru": "static-7.1104",
    "sk": "static-7.1104",
    "sl": "static-7.1104",
    "sv": "static-7.1104",
    "th": "static-7.1104",
    "tl": "static-7.1104",
    "tr": "static-7.1104",
    "uk": "static-7.1104",
    "vi": "static-7.1104",
    "x-pseudo": "static-7.1104",
    "zh-cn": "static-7.1104",
    "zh-hk": "static-7.1104",
    "zh-tw": "static-7.1104"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:ko', {version: 'static-7.1104'}); }
})();


